var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{on:{"!click":function($event){$event.stopPropagation();return _vm.doNothing.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }